export default function fixed(num) {
  if (!num) return 0;
  return Math.round(num * 100) / 100;
}